<!--  -->
<template>
    <div class="business-content-main recivable-content" v-loading="hLoading || saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                    <el-button v-if="permission.applyReceipt" size="small" type="warning" icon="el-icon-receiving" class="search-btn" @click="batchComfirms()">{{
                        permission.applyReceipt
                    }}</el-button>
                    <el-button v-if="permission.offsetAccount" size="small" type="danger" icon="el-icon-document-remove" class="search-btn" @click="offsetComfirms()">{{
                        permission.offsetAccount
                    }}</el-button>
                    <el-button
                        v-if="permission.buildAccount"
                        size="small"
                        type="primary"
                        icon="el-icon-document-add"
                        class="search-btn"
                        @click="showBuildAccount(false)"
                        >{{ permission.buildAccount }}</el-button
                    >
                    <el-button
                        v-if="permission.transAccount"
                        size="small"
                        type="primary"
                        icon="el-icon-document-copy"
                        class="search-btn"
                        @click="showTransAccount(false)"
                        >{{ permission.transAccount }}</el-button
                    >
                    <el-button v-if="permission.combineAccount" size="small" type="primary" icon="el-icon-s-finance" class="search-btn" @click="combineComfirms()">{{
                        permission.combineAccount
                    }}</el-button>
                    <el-button size="small" icon="el-icon-document-copy" class="search-btn btn-primary" @click="offsetRecords()" v-if="permission.offsetRecords">{{
                        permission.offsetRecords
                    }}</el-button>
                    <el-button
                        size="small"
                        icon="el-icon-document-copy"
                        class="search-btn btn-primary"
                        @click="buildAccountRecords()"
                        v-if="permission.buildAccountRecords"
                        >{{ permission.buildAccountRecords }}</el-button
                    >
                    <el-button size="small" icon="el-icon-document-copy" class="search-btn btn-primary" @click="transRecords()" v-if="permission.transRecords">{{
                        permission.transRecords
                    }}</el-button>
                    <el-button size="small" icon="el-icon-document-copy" class="search-btn btn-primary" @click="combineRecords()" v-if="permission.combineRecords">{{
                        permission.combineRecords
                    }}</el-button>
                    <el-button
                        size="small"
                        icon="el-icon-document-copy"
                        class="search-btn btn-primary"
                        @click="applyAdvanceReceived()"
                        v-if="permission.advanceRecords"
                        >{{ permission.advanceRecords }}</el-button
                    >
                    <div v-if="printList.length > 0" style="margin-left: 6px; margin-right: 6px">
                        <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                            permission.print
                        }}</el-button>
                        <el-button
                            v-if="permission.printPreview && !isDefaultSet"
                            size="small"
                            icon="el-icon-view"
                            class="search-btn btn-primary"
                            @click="printPreview()"
                            >{{ permission.printPreview }}</el-button
                        >
                        <el-button
                            v-if="(permission.printPreview || permission.print) && isDefaultSet"
                            size="small"
                            icon="el-icon-printer"
                            class="search-btn btn-primary"
                            @click="printPreview()"
                            >打印</el-button
                        >
                    </div>
                    <div v-else style="margin-left: 6px; margin-right: 6px">
                        <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="askPrintList()">{{
                            permission.print
                        }}</el-button>
                        <el-button
                            v-if="permission.printPreview && !isDefaultSet"
                            size="small"
                            icon="el-icon-view"
                            class="search-btn btn-primary"
                            @click="askPrintListPreview()"
                            >{{ permission.printPreview }}</el-button
                        >
                        <el-button
                            v-if="(permission.printPreview || permission.print) && isDefaultSet"
                            size="small"
                            icon="el-icon-printer"
                            class="search-btn btn-primary"
                            @click="askPrintListPreview()"
                            >打印</el-button
                        >
                    </div>
                    <el-button size="small" type="warning" class="search-btn" @click="gotoOutRecords()" v-if="permission.outRecords">{{
                        permission.outRecords
                    }}</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportForm">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button
                    >
                    <el-button v-if="permission.scanSearch" size="small" type="warning" class="search-btn" @click="scanComfirms()"
                        >{{ permission.scanSearch }} (F4)</el-button
                    >
                </div>
                <div class="search-ctn-right">
                    <div class="section-summary" v-loading="summaryLoading">
                        <div>
                            <span>{{ summaryStr ? summaryStr : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="receivable-table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="350"
                    ref="multipleTable"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    v-el-table-infinite-scroll="tableLoad"
                    empty-text="暂无未结数据"
                    @sort-change="sortChange"
                >
                    <el-table-column sortable="custom" show-overflow-tooltip width="120" prop="Tags" label="客户标签"></el-table-column>
                    <el-table-column show-overflow-tooltip width="220" prop="EntpCusName" label="客户"></el-table-column>
                    <el-table-column show-overflow-tooltip v-for="item in payWayList" width="100" :key="item.Value" :label="item.Text">
                        <template slot-scope="scope">
                            {{ payTypeAmout(item.Value, scope.row.UnpaidList) }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="RSumPayable" sortable="custom" label="欠款总额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="AgentSum" label="代收总额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="AdvanceMoney" label="预收款余额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="180" prop="ApplyTime" label="最近一次确认时间"></el-table-column>
                </el-table>
            </div>

            <div class="section-title">
                <div>
                    <span>确认的单据{{ applyTableDataLength > 0 ? '（共' + applyTableDataLength + '条）' : '' }}</span>
                    <el-button
                        v-if="applyTableDataLength > 0 && applyTableDataLength > searchData2.Limit"
                        size="small"
                        type="primary"
                        class="loadall-btn"
                        @click="loadAllData()"
                        >加载全部数据</el-button
                    >
                </div>
            </div>
            <div class="receivable-table-ctn">
                <el-table
                    v-loading="aLoading"
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="applyTableData"
                    height="350"
                    ref="multipleTable2"
                    :default-sort="{ prop: 'ConfirmTime', order: 'descending' }"
                    :row-key="getOrderRowKeys"
                    @row-click="applyRowClick"
                    @selection-change="handleSelectionChange"
                    v-el-table-infinite-scroll="orderLoad"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" prop="CusSourcesName" v-if="isShowSource" label="销售来源"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" prop="OrgName" label="部门"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" prop="ConfirmTime" label="确认时间" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" v-if="showSubmitTime" prop="SubmitTime" label="提交时间" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" v-if="showCreateTime" prop="CreateTime" label="创建时间" sortable></el-table-column>
                    <el-table-column width="230px" prop="OrderCode" label="单号">
                        <template slot-scope="scope">
                            <div class="i-content">
                                <span class="i-content" v-if="permission.offsetAccount && scope.row._rer && scope.row.OrderId"
                                    ><span class="i-sign">{{ scope.row._rer }}</span
                                    ><el-link
                                        :underline="false"
                                        :href="
                                            scope.row.OrderType == 0
                                                ? '/#/salesManage/salesOrder/check?id=' + scope.row.OrderId + '&type=1&entpCusId=' + scope.row.EntpCusId
                                                : '/#/salesManage/salesReturns/edit_v3?type=1&SReturnId=' + scope.row.OrderId
                                        "
                                        target="_blank"
                                        >{{ scope.row.OrderCode }}</el-link
                                    ></span
                                >
                                <i v-else-if="scope.row.OrderId"
                                    ><el-link
                                        :underline="false"
                                        :href="
                                            scope.row.OrderType == 0
                                                ? '/#/salesManage/salesOrder/check?id=' + scope.row.OrderId + '&type=1&entpCusId=' + scope.row.EntpCusId
                                                : '/#/salesManage/salesReturns/edit_v3?type=1&SReturnId=' + scope.row.OrderId
                                        "
                                        target="_blank"
                                        >{{ scope.row.OrderCode }}</el-link
                                    ></i
                                >
                                <i v-else>{{ scope.row.OrderCode }}</i>
                                <img
                                    v-show="scope.row.OrderId"
                                    src="@/assets/images/preview.png"
                                    title="打印预览"
                                    style="margin-left: 5px; width: 24px; height: 24px"
                                    @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId)"
                                />
                                <img
                                    v-show="scope.row.PRType == 11"
                                    src="@/assets/images/view.png"
                                    title="查看合并明细"
                                    style="margin-left: 5px; margin-top: 5px; width: 24px; height: 13px"
                                    @click.stop="viewCombineDetail(scope.row)"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="OrderType" label="单据类型">
                        <template slot-scope="scope">
                            <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                            <i v-else-if="scope.row.OrderType == 1" class="out-active">销售退货</i>
                            <i v-else-if="scope.row.OrderType == 2">合并帐</i>
                            <i v-else>建账</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="支付方式"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="应收总额">
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="AgentAmount" label="代收总额">
                        <template slot-scope="scope">{{ scope.row.IsAgent ? scope.row.AgentAmount : 0 }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="AlreadyPaid" label="已收总额">
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.AlreadyPaid : -scope.row.AlreadyPaid }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" label="欠款余额">
                        <template slot-scope="scope">{{
                            scope.row.OrderType != 1
                                ? scope.row.IsAgent
                                    ? (scope.row.TotalAmount - scope.row.AgentAmount - scope.row.AlreadyPaid).toFixed(2)
                                    : (scope.row.TotalAmount - scope.row.AlreadyPaid).toFixed(2)
                                : -(scope.row.TotalAmount - scope.row.AlreadyPaid).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                    <el-table-column show-overflow-tooltip width="75px" prop="SName" label="开单人"></el-table-column>
                    <el-table-column show-overflow-tooltip width="75px" prop="Confirmer" label="确认人"></el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="单据搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="85px">
                        <el-form-item label="客户">
                            <el-select
                                ref="search_0"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="客户名称/电话"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户标签">
                            <el-select
                                style="width: 100%"
                                class="search-item"
                                size="small"
                                filterable
                                clearable
                                v-model="searchData.Tags"
                                @visible-change="tagVisibleChange($event)"
                            >
                                <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支付方式">
                            <el-select style="width: 100%" class="search-item" size="small" filterable clearable multiple v-model="searchPayType">
                                <el-option v-for="optionItem in sreachPayWayList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="欠款总额">
                            <div class="flex">
                                <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                    <el-option key=">=" label=">=" value=">="></el-option>
                                    <el-option key=">" label=">" value=">"></el-option>
                                    <el-option key="<=" label="<=" value="<="></el-option>
                                    <el-option key="<" label="<" value="<"></el-option>
                                    <el-option key="=" label="=" value="="></el-option>
                                    <el-option key="!=" label="!=" value="!="></el-option>
                                    <el-option key="between" label="区间" value="between"></el-option>
                                </el-select>
                                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Amount1"></el-input>
                                <el-input
                                    class="search-item"
                                    size="small"
                                    style="width: 90px"
                                    v-model.trim="searchData.Amount2"
                                    v-if="searchData.Symbol == 'between'"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="预收款余额">
                            <div class="flex">
                                <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol2" clearable placeholder="符号">
                                    <el-option key=">=" label=">=" value=">="></el-option>
                                    <el-option key=">" label=">" value=">"></el-option>
                                    <el-option key="<=" label="<=" value="<="></el-option>
                                    <el-option key="<" label="<" value="<"></el-option>
                                    <el-option key="=" label="=" value="="></el-option>
                                    <el-option key="!=" label="!=" value="!="></el-option>
                                    <el-option key="between" label="区间" value="between"></el-option>
                                </el-select>
                                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Amount3"></el-input>
                                <el-input
                                    class="search-item"
                                    size="small"
                                    style="width: 90px"
                                    v-model.trim="searchData.Amount4"
                                    v-if="searchData.Symbol == 'between'"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <div style="border-top: 1px dashed #cccccc; height: 1px; overflow: hidden; margin-top: 10px; margin-bottom: 10px"></div>
                        <el-form-item label="部门">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData2.OrgId"
                                filterable
                                clearable
                                collapse-tags
                                reserve-keyword
                                @visible-change="orgVisibleChange($event)"
                                placeholder="请选择"
                            >
                                <el-option v-for="item in orgSearchData" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="确认日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】收欠款' : '收欠款'"
                :visible.sync="isShowApplyDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -500px"
            >
                <div v-if="isShowApplyDialog" class="settle-op-content">
                    <ApplyReceipt ref="applyReceipt" @closeDialog="closeDialog" :ApplyList="multipleSelection"></ApplyReceipt>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】冲账明细' : '冲账明细'"
                :visible.sync="isShowOffsetDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -600px"
            >
                <div v-if="isShowOffsetDialog" class="settle-op-content">
                    <OffsetReceipt ref="applyReceipt" @closeDialog="closeDialog" :OffsetType="0" :OffSetList="multipleSelection"></OffsetReceipt>
                </div>
            </el-dialog>
            <!--  打印  -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printCusReceivable
                        @closeDialog="closePrintDialog"
                        @printPreview="printPreview"
                        :ordersList="printList.length > 0 ? printList : printDialogList"
                        :isDefaultSet="isDefaultSet"
                        :isPreview="isPreview"
                        :isInit="true"
                    >
                    </printCusReceivable>
                </div>
            </el-dialog>
            <!-- 打印隐藏内容，用于直接打印 -->
            <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" v-if="isRegister">
                <printCusReceivable
                    ref="printDom"
                    @closeDialog="closePrintDialog"
                    :ordersList="printList"
                    :isDefaultSet="isDefaultSet"
                    :isPreview="isPreview"
                    :isInit="false"
                ></printCusReceivable>
            </div>
            <!--  打印列表弹窗 -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printListDialogVisible" width="870px">
                <div class="dialog-content" v-if="printListDialogVisible">
                    <printCusReceivableList
                        @closeDialog="closePrintDialog"
                        :sParams="searchParams"
                        :isDefaultSet="isDefaultSet"
                        :isPreview="isPreview"
                        :isInit="true"
                    ></printCusReceivableList>
                </div>
            </el-dialog>
            <!-- 打印列表隐藏内容，用于直接打印 -->
            <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important">
                <printCusReceivableList
                    ref="printListDom"
                    @closeDialog="closePrintDialog"
                    :sParams="searchParams"
                    :isDefaultSet="isDefaultSet"
                    :isPreview="isPreview"
                    :isInit="false"
                ></printCusReceivableList>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】建账' : '建账'"
                :visible.sync="isShowBuildDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="400px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -100px"
            >
                <div v-if="isShowBuildDialog" class="settle-op-content">
                    <BuildAccount ref="buildAccount" @closeDialog="closeBuildDialog" :CurrentData="currentApplyRow" :IsEdit="isEditApply" :CType="0"></BuildAccount>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="转帐"
                :visible.sync="isShowTransDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="400px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -100px"
            >
                <div v-if="isShowTransDialog" class="settle-op-content">
                    <TransAccount ref="transAccount" @closeDialog="closeTransDialog" :CurrentData="currentApplyRow"></TransAccount>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="预收款数据" :visible.sync="dialogApplyVisible" width="1400px">
                <div class="dialog-content" v-if="dialogApplyVisible">
                    <AdvanceReceipt ref="advanceReceipt" @closeReceipt="closeApplyDialog" :EntpCusId="EntpCusId" :EntpCusName="EntpCusName"></AdvanceReceipt>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview" width="870px">
                <div class="dialog-content" v-if="printOrderPreview">
                    <printContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :showDisc="showDisc" :isInit="true"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview" width="870px">
                <div class="dialog-content" v-if="printReturnPreview">
                    <printReturnContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="转帐记录" :visible.sync="dialogTransRecordsVisible" width="1000px">
                <div class="dialog-content" v-if="dialogTransRecordsVisible">
                    <TransRecords ref="transRecords" @closeRecords="closeTransRecordsDialog" :EntpCusId="EntpCusId" :EntpCusName="EntpCusName"></TransRecords>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】合并账明细' : '合并账明细'"
                :visible.sync="isShowCombineDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -600px"
            >
                <div v-if="isShowCombineDialog" class="settle-op-content">
                    <CombineRAndP ref="applyReceipt" @closeDialog="closeDialog" :CombineList="multipleSelection"></CombineRAndP>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="合并记录" :visible.sync="dialogComRecordsVisible" width="1000px">
                <div class="dialog-content" v-if="dialogComRecordsVisible">
                    <CombineRecords
                        ref="combineRecords"
                        @closeRecords="closeComRecords"
                        @printPreview="printPreview"
                        :EntpCusId="EntpCusId"
                        :EntpCusName="EntpCusName"
                    ></CombineRecords>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                append-to-body
                :title="'【' + EntpCusName + '】' + comCode + ' 合并明细'"
                :visible.sync="dialogDetailVisible"
                width="900px"
            >
                <div class="dialog-content" v-if="dialogDetailVisible">
                    <CombineDetails
                        @closeDetails="closeDetailDialog"
                        @printPreview="printPreview"
                        :RecordId="recordId"
                        :EntpCusName="EntpCusName"
                        :isDefaultSet="isDefaultSet"
                        :isPreview="isPreview"
                    ></CombineDetails>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="冲减记录" :visible.sync="dialogOffsetRecordsVisible" width="1000px">
                <div class="dialog-content" v-if="dialogOffsetRecordsVisible">
                    <OffsetRecords ref="combineRecords" @closeRecords="closeComRecords" :EntpCusId="EntpCusId" :EntpCusName="EntpCusName"></OffsetRecords>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="建账记录" :visible.sync="dialogBuildAccountVisible" width="1200px">
                <div class="dialog-content" v-if="dialogBuildAccountVisible">
                    <BuildAccountRecords
                        ref="combineRecords"
                        @closeRecords="closeComRecords"
                        :EntpCusId="EntpCusId"
                        :Permission="permission"
                        :EntpCusName="EntpCusName"
                    ></BuildAccountRecords>
                </div>
            </el-dialog>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="扫码搜索"
                :visible.sync="dialogScanVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="scan-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogScanVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="单号" style="margin-bottom: 0">
                            <el-input
                                class="search-name"
                                ref="inputdata"
                                v-model="scanData"
                                clearable
                                placeholder="请扫描销售单或退货单二维码"
                                size="small"
                                style="width: 250px"
                                @change="inputDataChange()"
                            ></el-input>
                        </el-form-item>
                        <div style="color: red">（使用扫码确认功能请确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
                    </el-form>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ApplyReceipt from '@/components/business/revenue_h/applyReceipt';
import OffsetReceipt from '@/components/business/revenue_h/offsetReceipt';
import breadcrumb from '@/components/common/breadcrumb';
// import printCusReceivable from '@/components/printModels/printCusReceivable';
import printCusReceivableList from '@/components/printModels/printCusReceivableList';
import BuildAccount from '@/components/business/revenue_h/buildAccount';
import TransAccount from '@/components/business/revenue_h/transAccount';
import AdvanceReceipt from '@/components/business/customerManage/advanceReceipt';
import TransRecords from '@/components/business/customerManage/transRecords';
import CombineRAndP from '@/components/business/revenue_h/combineRAndP';
import CombineRecords from '@/components/business/customerManage/combineRecords';
import CombineDetails from '@/components/business/customerManage/combineDetails';
import OffsetRecords from '@/components/business/customerManage/offsetRecords';
import BuildAccountRecords from '@/components/business/customerManage/buildAccountRecords';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ApplyReceipt,
        OffsetReceipt,
        // printCusReceivable,
        printCusReceivableList,
        BuildAccount,
        TransAccount,
        AdvanceReceipt,
        TransRecords,
        CombineRAndP,
        CombineRecords,
        CombineDetails,
        OffsetRecords,
        BuildAccountRecords
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                });
            }
        },
        tableData() {
            if (this.payWayList.length == 0) {
                this.getPay().then(() => {
                    if (this.searchPayType.length > 0) {
                        this.payWayList = this.sreachPayWayList.filter(x => this.searchPayType.some(one => one == x.Value));
                    } else {
                        this.payWayList = this.sreachPayWayList;
                    }
                    this.doLayout();
                });
            } else this.doLayout();
        }
    },
    data() {
        return {
            dialogDetailVisible: false,
            isShowCombineDialog: false,
            comCode: '',
            recordId: '',
            datetime1: [],
            datetime2: [],
            EntpCusId: '',
            EntpCusName: '',
            summaryStr: '',
            loading: false,
            hLoading: false,
            aLoading: false,
            isStopReq: false,
            cusName: '',
            isEditApply: false,
            multipleSelection: null,
            dialogVisible: false,
            isShowApplyDialog: false,
            isShowOffsetDialog: false,
            printDialogVisible: false,
            printDialogList: [],
            printListDialogVisible: false,
            isShowBuildDialog: false,
            isShowTransDialog: false,
            dialogApplyVisible: false,
            dialogTransRecordsVisible: false,
            dialogComRecordsVisible: false,
            dialogOffsetRecordsVisible: false,
            dialogBuildAccountVisible: false,
            scanData: '',
            dataindex: -1,
            stopFresh: true,
            stopOrderFresh: false,
            isShowSummary: false,
            tagsList: [],
            isStartSearch: false,
            searchData: {
                CId: '',
                Tags: '',
                Keyword: '',
                Symbol: '',
                Amount1: 0,
                Amount2: 0,
                Symbol2: '',
                Amount3: 0,
                Amount4: 0,
                SortProp: '',
                SortType: '',
                PayType: [],
                Page: 1,
                Limit: 25
            },
            searchData2: {
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CusId: '',
                OrgId: '',
                Page: 1,
                Limit: 15
            },
            searchParams: {},
            currentRow: {},
            currentApplyRow: {},
            tableData: [],
            applyTableData: [],
            orderGoodsData: [],
            tableDataLength: 0,
            permission: {},
            cusId: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            printList: [],
            isDefaultSet: true, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            askShowDisc: false,
            showDisc: false,
            printOrderPreview: false,
            printReturnPreview: false,
            idList: [],
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            dialogScanVisible: false,
            firstScanOrder: true,
            showSubmitTime: false,
            showCreateTime: false,
            isShowSource: false, //是否显示销售来源
            payWayList: [],
            sreachPayWayList: [],
            searchPayType: [],
            summaryLoading: false,
            applyTableDataLength: 0,
            orgSearchData: [],
            isRegister: false
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        // this.getPay();
    },
    mounted() {
        this.permission = this.$util.getPermission('CusReceivable_H');
        this.getConfigByCodes().then(() => {
            this.getPay().then(data => {
                this.getTableData();
            });
        });

        this.getPrintComponents();
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        getPay() {
            return new Promise(resolve => {
                this.$util.getPay().then(data => {
                    this.payWayList = data.filter(x => x.IsSpecial);
                    this.sreachPayWayList = data.filter(x => x.IsSpecial);
                    resolve(data);
                });
            });
        },
        payTypeAmout(value, list) {
            if (value) {
                var amount = 0;
                if (list != null && list.length > 0) {
                    var plist = list.filter(x => x.PayType == value);
                    plist.forEach(x => {
                        amount += x.Unpaid;
                    });
                }
                return amount.toFixed(2);
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['syllqdysz', 'dyyl', 'xwdyxxdxxyh', 'zkglzstjsj', 'zkglzscjsj', 'ssxsmxxzspsfxzly'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                                case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                    this.askShowDisc = result;
                                    break;
                                case 'zkglzstjsj': //显示提交时间
                                    this.showSubmitTime = result;
                                    break;
                                case 'zkglzscjsj': //显示创建时间
                                    this.showCreateTime = result;
                                    break;
                                case 'ssxsmxxzspsfxzly': //是否显示销售来源
                                    // 如果没有开启该配置的时候，不展示（避免明细售后单多个商品均为不同的销售来源）
                                    this.isShowSource = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleKeyEvent(e) {
            if (this.printDialogVisible || this.printListDialogVisible) return;
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                if (that.dialogVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                } else if (that.isShowApplyDialog) {
                    if (that.$refs.applyReceipt) {
                        that.$refs.applyReceipt.submitForm();
                    }
                }
            }
            //F4
            if (key === 115) {
                that.scanComfirms();
            }
            if (key === 27) {
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                } else if (that.isShowApplyDialog) that.isShowApplyDialog = false;
            }
            //下键
            if (key == 40) {
                e.preventDefault();
                if (that.dataindex != that.tableDataLength - 1) {
                    that.$refs.multipleTable2.clearSelection();
                    if (that.currentRow && that.currentRow.EntpCusId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getApplyTableData();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                e.preventDefault();
                if (that.dataindex != 0) {
                    that.$refs.multipleTable2.clearSelection();
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getApplyTableData();
                        }
                    });
                }
            }
            //ESC
            if (key === 27) {
                if (that.dialogScanVisible) that.dialogScanVisible = false;
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.Page += 1;
                else this.searchData.Page = 1;
                this.getTableData();
            }
        },
        orderLoad() {
            if (!this.stopOrderFresh) {
                if (this.applyTableData && this.applyTableData.length > 0) {
                    this.searchData2.Page += 1;
                    this.getApplyTableData();
                }
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            that.$refs.multipleTable2.clearSelection();
            that.dataindex = row.index;

            that.currentApplyRow = {};
            that.currentRow = row;

            if (that.currentRow && that.currentRow.EntpCusId && (that.searchData2.CusId != that.currentRow.EntpCusId || that.applyTableData.length == 0)) {
                that.searchData2.Page = 1;
                that.searchData2.Limit = 15;
                that.applyTableData = [];
                that.getApplyTableData();
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = [];
            this.printList = [];
            if (val.length > 0) {
                this.isShowSummary = true;
                let sa = 0; //销售总额
                let yshj = 0; //应收合计
                let sqhj = 0; //已申请合计
                let firstCus = '';
                for (let i = 0; i < val.length; i++) {
                    if (!val[i].IsCanStateBack) {
                        let oa = 0;
                        let ss = 0;
                        if (i == 0) {
                            firstCus = val[i].EntpCusId;
                            this.multipleSelection.push(val[i]);

                            oa = val[i].SumPayable;
                            ss = val[i].TotalAmount;
                        } else {
                            if (firstCus !== val[i].EntpCusId) {
                                this.$refs.multipleTable2.toggleRowSelection(val[i], false);
                            } else {
                                this.multipleSelection.push(val[i]);
                                oa = val[i].SumPayable;
                                ss = val[i].TotalAmount;
                            }
                        }

                        if (val[i].OrderType == 0) {
                            sa += oa;
                            yshj += ss;
                            if (val[i].IsCanStateBack) sqhj += ss;
                        } else {
                            sa -= oa;
                            yshj -= ss;
                            if (val[i].IsCanStateBack) sqhj -= ss;
                        }
                    }
                    val[i].EntpCusName = this.currentRow.EntpCusName;
                    this.printList.push(val[i]);
                }
            }
        },
        resetSearch() {
            this.searchData = {
                CId: '',
                Tags: '',
                Keyword: '',
                Symbol: '',
                Amount1: 0,
                Amount2: 0,
                Symbol2: '',
                Amount3: 0,
                Amount4: 0,
                SortProp: '',
                SortType: '',
                PayType: [],
                Page: 1,
                Limit: 25
            };
            this.searchPayType = [];
            this.searchData2 = {
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CusId: '',
                OrgId: '',
                Page: 1,
                Limit: 15
            };
            this.datetime1 = [];
            this.datetime2 = [];
            // this.searchCustom('');
            this.$refs.multipleTable2.clearSelection();
        },
        getTableData() {
            let that = this;
            if (!that.isStopReq) {
                if (that.searchData.Symbol) {
                    if (that.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(that.searchData.Amount1))) {
                            that.$util.warningMsg('请输入正确的金额');
                            return;
                        }
                        if (isNaN(parseInt(that.searchData.Amount2))) {
                            that.$util.warningMsg('请输入正确的金额');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(that.searchData.Amount1))) {
                            that.$util.warningMsg('请输入正确的金额');
                            return;
                        }
                    }
                } else {
                    that.searchData.Amount1 = 0;
                    that.searchData.Amount2 = 0;
                }
                if (that.searchData.Symbol2) {
                    if (that.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(that.searchData.Amount3))) {
                            that.$util.warningMsg('请输入正确的预收款余额');
                            return;
                        }
                        if (isNaN(parseInt(that.searchData.Amount4))) {
                            that.$util.warningMsg('请输入正确的预收款余额');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(that.searchData.Amount3))) {
                            that.$util.warningMsg('请输入正确的预收款余额');
                            return;
                        }
                    }
                } else {
                    that.searchData.Amount3 = 0;
                    that.searchData.Amount4 = 0;
                }

                if (that.searchPayType.length > 0) {
                    that.searchData.PayType = that.searchPayType;
                } else {
                    that.searchData.PayType = [];
                }
                if (that.searchData.Page == 1) {
                    that.searchParams = { ...that.searchData };
                    that.tableData = [];
                    that.tableDataLength = 0;
                    that.summaryStr = '';
                    that.applyTableData = [];
                } else {
                    that.searchParams.Page = that.searchData.Page;
                }
                that.stopFresh = true;
                that.hLoading = true;
                that.isStopReq = true;

                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/GetCusItemizedSummary',
                        data: that.searchParams,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (res.errcode != 201) {
                            if (data) {
                                if (that.searchData.Page == 1) {
                                    that.tableData = [];
                                    that.tableDataLength = res.count;
                                    that.summaryStr = data.SummaryStr;
                                    that.applyTableData = [];
                                    if (that.searchPayType.length > 0) {
                                        that.payWayList = that.sreachPayWayList.filter(x => that.searchPayType.some(one => one == x.Value));
                                    } else {
                                        that.payWayList = that.sreachPayWayList;
                                    }
                                }
                                let list = [...that.tableData, ...data.DataList];
                                that.tableData = list;
                                that.stopFresh = data.DataList.length < that.searchData.Limit;
                            }
                        } else {
                            that.stopFresh = that.tableData.length >= that.tableDataLength;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.isStopReq = false;
                        that.hLoading = false;
                    });
            }
        },
        getApplyTableData(scanData) {
            let that = this;
            var cid = '';
            // if (!scanData) {
            //     if (that.currentRow && that.currentRow.EntpCusId) {
            //         cid = that.currentRow.EntpCusId;
            //         that.aLoading = true;
            //     }
            // } else {
            //     cid = scanData;
            //     that.aLoading = true;
            // }
            if (that.currentRow && that.currentRow.EntpCusId) {
                cid = that.currentRow.EntpCusId;
                that.aLoading = true;
            }
            if (!cid) return;

            that.searchData2.CusId = cid;
            that.stopOrderFresh = true;
            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetCusOrdersAppliesList',
                    data: that.searchData2,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.aLoading = false;
                    if (res.errcode != 201) {
                        // that.applyTableDataLength = res.count;
                        // if (!data) {
                        //     that.applyTableData = [];
                        //     that.aLoading = false;
                        //     return;
                        // }
                        // that.applyTableData = res.data;

                        if (!data) {
                            if (that.searchData2.Page == 1) {
                                that.applyTableDataLength = 0;
                                that.applyTableData = [];
                            }
                            return;
                        } else {
                            if (that.searchData2.Page == 1) {
                                that.applyTableDataLength = res.count;
                                that.applyTableData = [];
                            }
                        }

                        let list = [...that.applyTableData, ...data];
                        that.applyTableData = list;
                        that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;

                        let os = that.applyTableData.filter(f => f.OrderType == 1 && f.ReOrderId && f.IsDeduct);
                        if (os && os.length > 0) {
                            for (let i = 0; i < os.length; i++) {
                                let item = os[i];
                                let reOrderId = os[i].ReOrderId;
                                that.applyTableData.forEach(ele => {
                                    if (ele.OrderId == reOrderId) {
                                        if (!ele._rer) {
                                            ele._rer = i + 1;
                                            item._rer = i + 1;
                                        } else {
                                            item._rer = ele._rer;
                                        }
                                        return;
                                    }
                                });
                            }
                        }
                    } else {
                        that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                    }
                })
                .catch(() => {
                    that.aLoading = false;
                });
        },
        handleSearch() {
            let that = this;
            if (that.$refs.multipleTable2) that.$refs.multipleTable2.clearSelection();
            if (
                that.applyTableData &&
                ((that.searchData2.StartDate && that.searchData2.EndDate) || (that.searchData2.UStartDate && that.searchData2.UEndDate) || that.searchData2.OrgId)
            ) {
                // if (that.searchData2.StartDate && that.searchData2.EndDate) {
                //     that.applyTableData = that.applyTableData.filter(f => {
                //         let data1 = new Date(f.CreateTime);
                //         let data2 = new Date(that.$util.formatDateV3(that.searchData2.StartDate));
                //         let data3 = new Date(that.$util.formatDateV3(that.searchData2.EndDate));
                //         return data1 >= data2 && data1 <= data3;
                //     });
                // }
                // if (this.searchData2.UStartDate && this.searchData2.UEndDate) {
                //     this.applyTableData = this.applyTableData.filter(f => {
                //         let data1 = new Date(f.ConfirmTime);
                //         let data2 = new Date(that.$util.formatDateV3(that.searchData2.UStartDate));
                //         let data3 = new Date(that.$util.formatDateV3(that.searchData2.UEndDate));
                //         return data1 >= data2 && data1 <= data3;
                //     });
                // }

                that.applyTableData = [];
                that.searchData2.Page = 1;
                that.getApplyTableData();
            } else {
                this.dataindex = 0;
                this.searchData.Page = 1;
                this.getTableData();
            }
        },
        batchComfirms() {
            let that = this;
            if (that.multipleSelection && that.multipleSelection.length > 0) {
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowApplyDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要收款的项');
            }
        },
        offsetComfirms() {
            let that = this;
            if (that.multipleSelection && that.multipleSelection.length > 1) {
                let os = that.multipleSelection.filter(f => f.OrderType == 0);
                if (os && os.length == 0) {
                    that.$util.warningMsg('冲账必须具备销售收款项');
                    return;
                } else if (os && os.length > 1) {
                    that.$util.warningMsg('冲账只能对冲一条销售收款项');
                    return;
                }

                let orderId = os[0].OrderId;
                let ors = that.multipleSelection.filter(f => f.OrderType == 1 && f.ReOrderId && f.IsDeduct);
                if (ors && ors.length == 0) {
                    that.$util.warningMsg('冲账必须具备跟单销售退货项，并应具备可冲减标识');
                    return;
                } else {
                    for (let index = 0; index < ors.length; index++) {
                        let item = ors[index];
                        if (item.ReOrderId) {
                            if (item.ReOrderId !== orderId) {
                                that.$util.warningMsg('销售单与退货单之间关联不一致，请重新操作');
                                return;
                            }
                        } else {
                            that.$util.warningMsg('请选择标识一致的确认单据进行操作');
                            return;
                        }
                    }
                }
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowOffsetDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要冲账项，必须同时具备收退两种类型的款项');
            }
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusId;
        },
        getOrderRowKeys(row) {
            return row.RecordId;
        },
        closeDialog(isEdit) {
            this.isShowApplyDialog = false;
            this.isShowOffsetDialog = false;
            this.isShowCombineDialog = false;
            let that = this;
            if (isEdit) {
                that.multipleSelection = null;
                that.searchData.Page = 1;
                that.tableData = [];
                that.applyTableData = [];
                that.resetSearch();
                that.getTableData();
            }
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (row.IsCanStateBack) return false;
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                if (this.cusId && this.cusId.length > 0) {
                    if (row.EntpCusId == this.cusId[0] && !row.IsCanStateBack) {
                        return true;
                    } else {
                        return false;
                    }
                } else return true;
            } else return true; //可勾选
        },
        gotoSettle(item) {
            if (item.SettleCode) {
                this.$router.push('/financeManage/settlements/customers?code=' + item.SettleCode);
            }
        },
        searchTags() {
            let url = '/api/EntpCustomers/GetEnterpriseCustomerTagList';
            this.loading = true;
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.tagsList = res.data;
                });
        },
        tagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.tagsList.length == 0) that.searchTags();
            }
        },
        // 打印预览
        printPreview(data) {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            ///这里是在查看合并明细里需要打印明细的单据，
            ///但是发现在子组件里面能显示但是打印的时候就没有内容赋值，所以在子组件调用父组件的打印方法 - lzn 24-09-27
            if (!data) {
                if (this.printList.length == 0) {
                    this.$util.warningMsg('请选择单打印');
                    return;
                }
            } else this.printDialogList = data;
            this.printDialogVisible = true;
        },
        print() {
            if (this.printList.length == 0) {
                this.$util.warningMsg('请选择单打印');
                return;
            }
            this.$refs.printDom.init(true);
        },
        askPrintListPreview() {
            let that = this;
            this.$util.elConfirm({
                content: '当前未勾选单据明细，是否打印筛选的客户汇总表？',
                noMsg: true,
                confirm() {
                    that.printListDialogVisible = true;
                }
            });
        },
        askPrintList() {
            let that = this;
            this.$util.elConfirm({
                content: '当前未勾选单据明细，是否打印筛选的客户汇总表？',
                noMsg: true,
                confirm() {
                    that.$refs.printListDom.init(true);
                }
            });
        },
        closePrintDialog() {
            this.printDialogVisible = false;
            this.printListDialogVisible = false;
        },
        showBuildAccount(isEdit) {
            this.isShowBuildDialog = true;
            this.isEditApply = false;
            if (isEdit) this.isEditApply = isEdit;

            if (this.currentRow && this.currentRow.EntpCusId) {
                this.currentApplyRow.EntpCusId = this.currentRow.EntpCusId;
                this.currentApplyRow.EntpCusName = this.currentRow.EntpCusName;
            }
        },
        closeBuildDialog(isEdit) {
            this.isShowBuildDialog = false;
            this.isEditApply = false;
            if (isEdit) {
                this.$refs.multipleTable2.clearSelection();
                this.multipleSelection = null;
                this.searchData.Page = 1;
                this.tableData = [];
                this.applyTableData = [];
                this.getTableData();
            }
        },
        applyRowClick(row, column, event) {
            this.currentApplyRow = row;
        },
        delAccount() {
            let that = this;
            if (that.currentApplyRow && that.currentApplyRow.RecordId && (that.currentApplyRow.PRType == 10 || that.currentApplyRow.PRType == 4)) {
                that.$confirm('您确定要删除该款项吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.aLoading = true;
                        that.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_H/DelAccountRecords?recordId=${that.currentApplyRow.RecordId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('删除成功');
                                if (that.applyTableData.length == 1) {
                                    that.$refs.multipleTable2.clearSelection();
                                    that.multipleSelection = null;
                                    that.searchData.Page = 1;
                                    that.tableData = [];
                                    that.applyTableData = [];
                                    that.getTableData();
                                } else
                                    for (let index = 0; index < that.applyTableData.length; index++) {
                                        if (that.applyTableData[index].RecordId == that.currentApplyRow.RecordId) {
                                            that.applyTableData.splice(index, 1);
                                            return;
                                        }
                                    }
                            })
                            .catch(() => {})
                            .finally(() => {
                                this.aLoading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        showTransAccount() {
            let that = this;
            if (that.currentApplyRow) {
                if (that.currentApplyRow.PRType == 0 || that.currentApplyRow.PRType == 3) {
                    if (that.currentApplyRow.IsAgent) {
                        this.$util.warningMsg('代收账款不允许进行转帐');
                        return;
                    }
                    if (this.currentRow && this.currentRow.EntpCusId) {
                        this.currentApplyRow.EntpCusId = this.currentRow.EntpCusId;
                        this.currentApplyRow.EntpCusName = this.currentRow.EntpCusName;
                    }
                    this.isShowTransDialog = true;
                } else {
                    this.$util.warningMsg('请选择销售收款或销售退货的单据');
                }
            } else {
                this.$util.warningMsg('请点击确认的单据行进行选择');
            }
        },
        closeTransDialog(isEdit, tranAmount, toEntpCusId) {
            let that = this;
            that.isShowTransDialog = false;
            if (isEdit) {
                that.$refs.multipleTable2.clearSelection();
                that.multipleSelection = null;
                if (that.currentRow && that.currentRow.EntpCusId) {
                    for (let i = 0; i < that.tableData.length; i++) {
                        if (that.currentRow.EntpCusId == that.tableData[i].EntpCusId) {
                            that.tableData[i].RSumPayable = (that.tableData[i].RSumPayable - tranAmount).toFixed(2);
                        }
                        if (toEntpCusId && toEntpCusId == that.tableData[i].EntpCusId) {
                            that.tableData[i].RSumPayable = (that.tableData[i].RSumPayable + tranAmount * 1).toFixed(2);
                        }
                    }
                }
                for (let index = 0; index < that.applyTableData.length; index++) {
                    if (that.applyTableData[index].RecordId == that.currentApplyRow.RecordId) {
                        if (
                            tranAmount == that.applyTableData[index].TotalAmount ||
                            (that.applyTableData[index].OrderType == 1 && tranAmount == -that.applyTableData[index].TotalAmount)
                        ) {
                            that.applyTableData.splice(index, 1);
                        } else {
                            if (that.applyTableData[index].OrderType != 1) {
                                that.applyTableData[index].TotalAmount = (that.applyTableData[index].TotalAmount - tranAmount).toFixed(2);
                                // that.applyTableData[index].AlreadyPaid = (that.applyTableData[index].AlreadyPaid + tranAmount * 1).toFixed(2);
                            } else {
                                that.applyTableData[index].TotalAmount = (that.applyTableData[index].TotalAmount + tranAmount * 1).toFixed(2);
                                // that.applyTableData[index].AlreadyPaid = (that.applyTableData[index].AlreadyPaid - tranAmount * 1).toFixed(2);
                            }
                        }
                        return;
                    }
                }
            }
        },
        applyAdvanceReceived() {
            if (this.currentRow && this.currentRow.EntpCusId) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogApplyVisible = true;
        },
        closeApplyDialog() {
            this.dialogApplyVisible = false;
        },
        transRecords() {
            if (this.currentRow && this.currentRow.EntpCusId) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogTransRecordsVisible = true;
        },
        closeTransRecordsDialog() {
            this.dialogTransRecordsVisible = false;
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData2.StartDate = val[0];
                this.searchData2.EndDate = val[1];
            } else {
                this.searchData2.StartDate = '';
                this.searchData2.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData2.UStartDate = val[0];
                this.searchData2.UEndDate = val[1];
            } else {
                this.searchData2.UStartDate = '';
                this.searchData2.UEndDate = '';
            }
        },
        viewOrderDetail(orderType, orderId) {
            if (orderId) {
                this.idList.push(orderId);
                if (orderType == 0) {
                    if (!this.askShowDisc) this.printOrderPreview = true;
                    else {
                        this.showDisc = true;
                        this.$confirm('是否打印显示优惠价？', '提示', {
                            confirmButtonText: '是',
                            cancelButtonText: '否',
                            type: 'warning'
                        })
                            .then(() => {
                                this.showDisc = true;
                                this.printOrderPreview = true;
                            })
                            .catch(() => {
                                this.showDisc = false;
                                this.printOrderPreview = true;
                            });
                    }
                } else if (orderType == 1) {
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(10).then(data => {
                if (data) {
                    Vue.component('printCusReceivable', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printCusReceivable', () => import('@/components/printModels/printCusReceivable'));
                    that.isRegister = true;
                }
            });
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printSales'));
                }
            });

            that.$util.getPrintComponents(4).then(data => {
                if (data) {
                    Vue.component('printReturnContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printReturnContent', () => import('@/components/printModels/printSaleReturn'));
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
        gotoOutRecords() {
            this.$router.push(`/financeManage/outRecords`);
        },
        // 导出
        exportForm() {
            let that = this;
            if (that.printList.length > 0) {
                this.$util.elConfirm({
                    content: '确定导出客户明细表吗？',
                    noMsg: true,
                    confirm() {
                        let EntpCusName = that.printList[0].EntpCusName;
                        that.$util.exportFile_post({
                            url: '/api/RevenueManagement_H/ExportCusOrdersAppliesList',
                            data: {
                                EntpCusName: EntpCusName,
                                ExportList: that.printList
                            }
                        });
                    }
                });
            } else {
                that.$confirm('未选择导出明细，是否导出客户汇总表？如果数据过多可能耗时稍长', '提醒', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.exportData();
                    })
                    .catch(() => {
                        return;
                    });
            }
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 100;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData };
            reqData.Limit = saveLimit;
            reqData.Page = that.currtPage;

            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetCusItemizedSummaryToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.tableDataLength <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/RevenueManagement_H/ExportCusItemizedSummary'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        },
        combineComfirms() {
            let that = this;
            if (that.multipleSelection && that.multipleSelection.length > 1) {
                let os2 = that.multipleSelection.filter(f => f.PRType == 11);
                if (os2 && os2.length > 1) {
                    that.$util.warningMsg('合并帐明细中不可以包含两条合并帐条目');
                    return;
                }

                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowCombineDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要的合并项，需要勾选两条或两条以上进行合并');
            }
        },
        combineRecords() {
            if (this.currentRow && this.currentRow.EntpCusId) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogComRecordsVisible = true;
        },
        viewCombineDetail(item) {
            if (this.currentRow && this.currentRow.EntpCusId) {
                this.EntpCusName = this.currentRow.EntpCusName;
                item.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusName = '';
            }
            this.recordId = item.RecordId;
            this.comCode = item.OrderCode;
            this.dialogDetailVisible = true;
        },
        closeComRecords() {
            if (this.dialogOffsetRecordsVisible) this.dialogOffsetRecordsVisible = false;
            if (this.dialogComRecordsVisible) this.dialogComRecordsVisible = false;
            if (this.dialogBuildAccountVisible) this.dialogBuildAccountVisible = false;
        },
        closeDetailDialog(isEdit) {
            if (isEdit) {
                if (this.currentRow) {
                    this.getApplyTableData();
                }
            }
            this.dialogDetailVisible = false;
        },
        offsetRecords() {
            if (this.currentRow) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogOffsetRecordsVisible = true;
        },
        buildAccountRecords() {
            if (this.currentRow) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogBuildAccountVisible = true;
        },
        scanComfirms() {
            this.dialogScanVisible = true;
            this.inputblur();
        },
        // 失去焦点 持续聚焦这个会影响查询弹窗的操作，所有在第一次打开聚焦就好
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            that.$nextTick(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            });
        },
        inputDataChange() {
            let that = this;
            that.resetSearch();
            //扫码客户二维码很难扫出内容，现在通过订单号+'CUST'作为客户标识生成条形码，通过订单号得出客户Id
            if (that.scanData.indexOf('XS') > -1 || that.scanData.indexOf('XSTH') > -1 || that.scanData.indexOf('CUST') > -1) {
                that.searchData.CId = that.scanData;
                that.tableData = [];
                that.searchParams = { ...that.searchData };
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/GetCusItemizedSummary',
                        data: that.searchData
                    })
                    .then(res => {
                        that.applyTableData = [];
                        let data = res.data;
                        if (!data ||(data&&data.DataList==0)) {
                            that.$util.warningMsg('未检测到相应的数据');
                            that.searchData.CId = '';
                            return;
                        }
                        that.tableData = data.DataList;
                        that.tableDataLength = res.count;
                        that.summaryStr = data.SummaryStr;
                        that.currentRow = that.tableData[0];
                        that.getApplyTableData(that.searchData.CId);
                        that.searchData.CId = '';
                    })
                    .catch(err => {
                        that.searchData.CId = '';
                    });
            }
            that.scanData = '';
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.Page = 1;
            this.getTableData();
        },
        // 重新渲染table组件，用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
        doLayout() {
            this.$nextTick(() => {
                this.$refs.multipleTable.doLayout();
                this.$refs.multipleTable2.doLayout();
            });
        },
        loadAllData() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpCusId) that.aLoading = true;
            that.searchData2.CusId = that.currentRow.EntpCusId;
            that.searchData2.Page = 1;
            that.searchData2.Limit = that.applyTableDataLength;

            if (that.searchData2.CusId) {
                that.stopOrderFresh = true;
                that.$util
                    .axiosGet({
                        url: '/api/RevenueManagement_H/GetCusOrdersAppliesList',
                        data: that.searchData2,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        that.aLoading = false;
                        if (res.errcode != 201) {
                            if (!data) {
                                if (that.searchData2.Page == 1) {
                                    that.applyTableDataLength = 0;
                                    that.applyTableData = [];
                                }
                                return;
                            } else {
                                if (that.searchData2.Page == 1) {
                                    that.applyTableDataLength = res.count;
                                    that.applyTableData = [];
                                }
                            }

                            let list = [...that.applyTableData, ...data];
                            that.applyTableData = list;

                            let os = that.applyTableData.filter(f => f.OrderType == 1 && f.ReOrderId && f.IsDeduct);
                            if (os && os.length > 0) {
                                for (let i = 0; i < os.length; i++) {
                                    let item = os[i];
                                    let reOrderId = os[i].ReOrderId;
                                    that.applyTableData.forEach(ele => {
                                        if (ele.OrderId == reOrderId) {
                                            if (!ele._rer) {
                                                ele._rer = i + 1;
                                                item._rer = i + 1;
                                            } else {
                                                item._rer = ele._rer;
                                            }
                                            return;
                                        }
                                    });
                                }
                            }

                            that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                        } else {
                            that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                        }
                    })
                    .catch(() => {
                        that.aLoading = false;
                    });
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;

    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;

        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}

#search-dc-dialog,
#scan-dc-dialog,
#apply-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    z-index: 99 !important;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

#apply-dialog::-webkit-scrollbar {
    display: none;
}

.v-content {
    width: 100%;
    height: calc(100vh);
}

.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.i-content {
    display: flex;
    flex-direction: row;
}

.i-sign {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border: 3px solid rgb(255, 88, 88);
    border-radius: 50%;
    font-weight: 700;
    color: rgb(50, 146, 31);
    margin-right: 5px;
}

.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}

.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}

.loadall-btn {
    margin-top: 4px;
    height: 24px;
    // width: 25px;
    line-height: 24px;
    padding: 0 5px;
    margin-right: 5px;
    margin-left: 10px;
}
</style>
<style lang="less">
.receivable-table-ctn {
    .el-link {
        justify-content: flex-start;
    }

    .el-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 4px 0;
                }
            }
        }

        th {
            padding: 4px 0;
        }

        margin-bottom: 10px;
    }

    .el-table__footer {
        td {
            padding: 4px 0;
        }
    }
}
</style>
